export function newPreacher(preacher) {
  return {
    type: "NEW_PREACHER",
    data: preacher
  };
}

export function editPreacher(preacher) {
  return {
    type: "EDIT_PREACHER",
    data: preacher
  };
}



// WEBPACK FOOTER //
// ./src/actions/preachers.js